import _ from "lodash";
import { Address, getAddress } from "viem";
import { ChainArch } from "./chains";


// viem until a node process installs the WASM checksum from @umi/core.
let checksum: (address: string) => Address = getAddress;
export const setAddressChecksum = (fn: (address: string) => Address) => {
  checksum = fn;
};

// Normalize addresses to a checksumed format
export function normalizeAddresses<T extends ChainArch>(
  addresses: string[],
  arch?: T
): T extends "EVM" ? Address[] : string[] {
  if (arch === "EVM" || arch === undefined) return _.map(addresses, (a) => normalizeAddress(a)) as any;
  return addresses as any;
}

// Normalize address to a checksumed format
// export const normalizeAddress = (address: string) => address.toLowerCase() as `0x${string}`;
export const normalizeAddress = (address: string) => checksum(address);

// Check if two addresses are the same after normalization
export const sameAddress = (a: Address | string, b: Address | string) => normalizeAddress(a) === normalizeAddress(b);


// 40 hex chars. A repeated block of any of these lengths fills the address.
const REPEAT_LENGTHS = [1, 2, 4, 5, 8, 10, 20];

// Words people stack or drop into an otherwise zero address.
const PLACEHOLDER_CORE = /^(?:dead|beef|cafe|babe|face|feed|c0de|c0ffee|deface|eeee|ffff)+$/;

// True for the zero address, 0x1111..., 0xdead..., 0xdeadbeef..., and the
// same shapes with the marker padded by zeros.
export const isPlaceholderAddress = (address: string) => {
  const hex = address.slice(2).toLowerCase();
  if (!/^[0-9a-f]{40}$/.test(hex)) return false;

  for (const size of REPEAT_LENGTHS) {
    const unit = hex.slice(0, size);
    if (unit.repeat(hex.length / size) === hex) return true;
  }

  const core = hex.replace(/^0+/, "").replace(/0+$/, "");
  if (core.length <= 8) return true;
  return PLACEHOLDER_CORE.test(core);
};
